import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  publisher: {
    activeTab: 'Top Publisher', // Default active tab for table 1
  },
  servicePublisher: {
    activeTab: 'Top Publisher', // Default active tab for table 2
  },
  dashboardNavigation: {
    activeTab: 'Overview', 
  },
};

const TabSlice = createSlice({
  name: 'tab',
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      const { tableName, tabName } = action.payload;
      state[tableName].activeTab = tabName;
    },
  },
});

export const { setActiveTab } = TabSlice.actions;

export default TabSlice.reducer;